import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexBasiccard',
  setup(__props) {

const BasicFlat = defineAsyncComponent(() => import("@/components/theme/advance/basic/BasicFlat.vue"))
const ShadowCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/ShadowCard.vue"))
const IconCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/IconCard.vue"))
const DarkCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/DarkCard.vue"))
const FooterCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/FooterCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Basic Card",
      title: "Basic Card"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicFlat)),
        _createVNode(_unref(ShadowCard)),
        _createVNode(_unref(IconCard)),
        _createVNode(_unref(DarkCard)),
        _createVNode(_unref(FooterCard))
      ])
    ])
  ], 64))
}
}

})